import { UserRoles } from "~enums/userRoles";

export const userRolesByPriority: UserRoles[] = [
  UserRoles.OrganizationAdmin,
  UserRoles.OrganizationManager,
  UserRoles.LeagueAdmin,
  UserRoles.LeagueManager,
  UserRoles.CompetitionAdmin,
  UserRoles.CompetitionManager,
  UserRoles.SeasonAdmin,
  UserRoles.SeasonManager,
  UserRoles.EntityGroupAdmin,
  UserRoles.EntityGroupManager,
  UserRoles.EntityManager,
  UserRoles.FixtureManager,
  UserRoles.RoleManager,
  UserRoles.SupportObserver,
];
